export default {
  heteroevaluation: 'Heteroevaluación',
  coevaluation: 'Coevaluación',
  autoevaluation: 'Autoevaluación'
}

export const en = {
  heteroevaluation: 'Heteroevaluation',
  coevaluation: 'Coevaluation',
  autoevaluation: 'Self-assessment'
}

export const ca = {
  heteroevaluation: 'Heteroavaluació',
  coevaluation: 'Cooavaluació',
  autoevaluation: 'Autoavaluació'
}
